/**
 * zh-CN
 * */

export default {
    nav: {
        home: '首页',
        tranning: '实训',
        competitions: '竞赛',
        discussion: '社区',
        datasets: '数据集',
        holdCompetition: '我要办赛',
        information: '资讯',
        message: '消息',
        login: '登录',
        register: '注册',
        mymainpage: '我的主页',
        editsetting: '帐号设置',
        signout: '退出',
        work:'工作台',
    },
    home: {
        search: '搜索',
    }
};
